module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-Regular.cc0b16c8.otf";